(() => {
	const initSlider = (block) => {
		if (block.dataset.sliderReady === "true") return;

		const imageSlides = Array.from(block.querySelectorAll(".image-slider > .slide"));
		const textSlides = Array.from(block.querySelectorAll(".text-slider > .slide"));
		const controls = block.querySelector(".controls");
		const slideCount = Math.min(imageSlides.length, textSlides.length);

		if (!controls || slideCount === 0) return;

		block.dataset.sliderReady = "true";
		let activeIndex = 0;

		controls.innerHTML = `
			<button class="slider-arrow slider-prev" type="button" aria-label="Previous slide">&#8249;</button>
			<span class="slider-count" aria-live="polite"></span>
			<button class="slider-arrow slider-next" type="button" aria-label="Next slide">&#8250;</button>
		`;

		const count = controls.querySelector(".slider-count");

		const showSlide = (index) => {
			activeIndex = (index + slideCount) % slideCount;

			imageSlides.forEach((slide, slideIndex) => {
				slide.classList.toggle("is-active", slideIndex === activeIndex);
			});
			textSlides.forEach((slide, slideIndex) => {
				slide.classList.toggle("is-active", slideIndex === activeIndex);
			});

			count.textContent = `${activeIndex + 1} / ${slideCount}`;
		};

		controls.querySelector(".slider-prev").addEventListener("click", () => showSlide(activeIndex - 1));
		controls.querySelector(".slider-next").addEventListener("click", () => showSlide(activeIndex + 1));
		showSlide(0);
	};

	const initAll = () => {
		document.querySelectorAll(".block-lp-product-slider").forEach(initSlider);
	};

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", initAll);
	} else {
		initAll();
	}

	if (window.acf?.addAction) {
		window.acf.addAction("render_block_preview", initAll);
	}
})();
